
<div>
    <!-- create contact edit -->
    <d-contact-edit
        v-model      = "create"
        :contact-id  = "contact ? contact.id : null"
        :company-id  = "companyId ? companyId : customerId"
        :customer-id = "customerId"
        :mode        = "mode"
        @saved       = "onSaved"
    />
    <!-- create contact edit -->

    <!-- contact combine -->
    <d-contact-combine
        v-model   = "combine"
        :contact  = "contact"
        :contacts = "items"
        @combined = "onCombined"
    />
    <!-- contact combine -->

    <c-card-iterator
        :label         = "$t('contact.title')"
        v-if           = "items"
        :items         = "items"
        :item-height   = "190"
        :filter-height = "180"
        :pagination-on = "true"
        :total-visible = "5"
        :filter        = "contactFilter"
        :key           = "refresh"
        class          = "w-100"
        ref            = "iterator"
    >
        <template v-slot:toolbar>
            <div class="pl-1" style="margin-top: -2px">
                <c-toolbar-button
                    :size    = "20"
                    icon     = "mdi-account-plus"
                    color    = "white"
                    :tooltip = "$t('contact.create')"
                    @click   = "onCreate"
                />
            </div>
        </template>

        <template v-slot:filter>
            <v-row class="no-frame mt-2" v-if="customerId">
                <v-col class="no-frame pr-2 col-5">
                    <v-checkbox
                        label   = "Kontakt Kunde"
                        v-model = "filter.customer"
                        class   = "mt-0 contract-label"
                        :ripple = "false"
                        @change = "onChange"
                        hide-details
                    />
                </v-col>
                <v-col class="no-frame pl-0 col-7">
                    <v-checkbox
                        label  = "Kontakt vor Ort"
                        v-model = "filter.onsite"
                        class   = "mt-0 contract-label"
                        :ripple = "false"
                        @change = "onChange"
                        hide-details
                    />
                </v-col>
            </v-row>
            <v-row class="no-frame mt-2">
                <v-col class="no-frame col-5">
                    <v-checkbox
                        label   = "Aktiv"
                        v-model = "filter.active"
                        class   = "mt-0 contract-label"
                        :ripple = "false"
                        @change = "onChange"
                        hide-details
                    />
                </v-col>
                <v-col class="no-frame col-7">
                    <v-checkbox
                        v-if    = "selectable"
                        label   = "nur Kundenkontakte"
                        v-model = "filter.customerContact"
                        class   = "mt-0 contract-label"
                        :ripple = "false"
                        @change = "onOnlyAssignedContact"
                        hide-details
                    />
                </v-col>
            </v-row>
            <v-row class="no-frame mt-2">
                <v-col class="no-frame col-5">
                    <v-checkbox
                        label  = "inaktiv"
                        v-model = "filter.inactive"
                        class   = "mt-0 contract-label"
                        :ripple = "false"
                        @change = "onChange"
                        hide-details
                    />
                </v-col>
                <v-col class="no-frame col-7">
                    <v-checkbox
                        label   = "Zum Löschen vorgemerkt"
                        v-model = "filter.remove"
                        class   = "mt-0 contract-label"
                        :ripple = "false"
                        @change = "onChange"
                        hide-details
                    />
                </v-col>
            </v-row>
        </template>

        <template v-slot:card="{ item }">
            <c-contact-card
                :contact         = "item"
                :background      = "background(selected, item)"
                :customer-id     = "customerId"
                :mode            = "mode"
                :combine-allowed = "true"
                @saved           = "onSaved"
                @selected        = "onSelected(item)"
                @combine         = "onCombine"
            />
       </template>
    </c-card-iterator>
</div>
